module.exports = __webpack_public_path__ + "static/media/lego5.141979e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lego5.png
// module id = 292
// module chunks = 0